import { Divider, Row, Shape, Title } from '@teko/ds-mobile';
import { useProductDetailState, useTenantConfig } from 'contexts';
import { t } from 'i18n';
import React from 'react';
import { ProductRatingList } from '../../desktop/DetailPageSGC/ProductRating';
import { RatingOverview } from './RatingOverview';

export const ReviewSection: React.FC = () => {
  const { productRatingData } = useProductDetailState();
  const { epicOmni1550HideReviewButton } = useTenantConfig();

  // Hide review section when this config on & no rating data
  if (epicOmni1550HideReviewButton && !productRatingData.totalReviews)
    return null;

  return (
    <Shape
      id="review-section"
      backgroundColor="white"
      borderRadius="xl"
      margin={['s8', 's0']}
    >
      <Row
        align="middle"
        justify="start"
        padding="s16"
        borderBottom="1px solid #0000000F"
      >
        <Title level={2} color="textTitle">
          {t('Đánh giá')}
        </Title>
      </Row>
      <RatingOverview ratingData={productRatingData} />
      <Divider color="#0000000F" gap={0} />
      {!!productRatingData.totalReviews && (
        <ProductRatingList ratingData={productRatingData} />
      )}
    </Shape>
  );
};
